<!-- 普通用户或者管理员的后台管理页面底部版权申明 -->
<template>
<footer class="v_tc">
  Copyright(C)www.deepcam.cn All Rights Reserved &nbsp;&nbsp;&nbsp;{{showLang('publicHome.footer.phone')}}:&nbsp;&nbsp;0755-61886461{{showLang('publicHome.footer.shenzhen')}}/ 027-87001788{{showLang('publicHome.footer.wuhan')}}
</footer>
</template>

<script>
export default {
  name: '',
  data() {
    return {

    }
  }
}
</script>

<style scoped>
footer {
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 0 18px;
  height: 40px;
  line-height: 40px;
  /* background-color: #001529; */
  color: #000;
  font-size: 12px
}
</style>



// WEBPACK FOOTER //
// src/components/public/footer.vue